import { useModules } from '@entities/common/index.ts';
import cn from 'classnames';
import { NavLink, useLocation } from 'react-router-dom';
import { openNotReadyModuleNotify } from '@widgets/header/helpers.ts';
import { useAppDispatch, usePlatformSettings } from '@shared/hooks/index.ts';
import * as st from './styles.module.scss';

export const DesktopLinks: React.FC = () => {
  const { modules } = useModules();

  const location = useLocation();
  const { is_demo } = usePlatformSettings();
  const dispatch = useAppDispatch();
  return (
    <>
      {modules.map((mod) => {
        const isActive = location.pathname.includes(`${mod.code}`);

        const linkTo = `/${mod.module_type}/${mod.code}`;

        return (
          mod.module_type !== 'statistics' && (
            <NavLink
              id={`${mod.id}-${mod.module_type}`}
              key={mod.id}
              to={linkTo}
              onClick={(e) => {
                if (is_demo && mod.verbose_name === 'Встречи') {
                  e.preventDefault();
                  dispatch(openNotReadyModuleNotify());
                }
              }}
              className={cn(st.nav__link, { [st.active]: isActive })}
            >
              {mod.verbose_name}
            </NavLink>
          )
        );
      })}
    </>
  );
};
